var player

function onYouTubeIframeAPIReady() {
	player = new YT.Player("player", {
		videoId: "EXAMPLE_VIDEO_ID", // Coloque o ID do vídeo do YouTube aqui
		playerVars: {
			autoplay: 1,
			mute: 1,
			controls: 0,
			rel: 0,
			modestbranding: 1,
		},
		events: {
			onReady: onPlayerReady,
		},
	})
}

function onPlayerReady(event) {
	event.target.playVideo() // Inicia o vídeo automaticamente
}

function togglePlayPause() {
	var state = player.getPlayerState()
	if (state == YT.PlayerState.PLAYING) {
		player.pauseVideo() // Pausa o vídeo
	} else if (state == YT.PlayerState.PAUSED || state == YT.PlayerState.CUED) {
		player.playVideo() // Reproduz o vídeo
	}
}

gsap.registerPlugin(MotionPathPlugin, ScrollTrigger)

gsap.to(".video-scroll", {
	scrollTrigger: {
		trigger: ".video-scroll",
		start: "-300 center",
		end: "100 center",
		toggleActions: "restart pause reverse pause",
		scrub: true,
	},
	y: -700,
	duration: 5,
})

document.addEventListener("DOMContentLoaded", function () {
	const mobileSelect = document.getElementById("v-pills-mobile")

	if (mobileSelect) {
		mobileSelect.addEventListener("change", function () {
			const selectedValue = this.value

			document.querySelectorAll(".tab-pane").forEach((tab) => {
				tab.classList.remove("show", "active")
			})

			const selectedTab = document.getElementById(selectedValue)
			if (selectedTab) {
				selectedTab.classList.add("show", "active")
			}
		})
	}
})

document.querySelectorAll(".projetos .nav-link").forEach(function (pill) {
	pill.addEventListener("click", function () {
		const roda1 = document.querySelector(".roda1")
		const roda2 = document.querySelector(".roda2")

		gsap.to(roda1, {
			rotation: -90,
			y: -100,
			opacity: 0,
			duration: 0.5,
			ease: "power2.inOut",
			onComplete: function () {
				gsap.set(roda1, { rotation: 0, y: 0 })
			},
		})

		gsap.fromTo(
			roda2,
			{ rotation: 90, y: 100, opacity: 0 },
			{
				rotation: 0,
				y: 0,
				opacity: 1,
				duration: 0.5,
				ease: "power2.inOut", // Suavização
				onComplete: function () {
					roda1.classList.toggle("roda1")
					roda1.classList.toggle("roda2")
					roda2.classList.toggle("roda1")
					roda2.classList.toggle("roda2")
				},
			}
		)
	})
})

console.log("testando js")
